/**
 * Interfaces para el manejo de exportaciones
 */
export enum ExportStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELLED = 'cancelled'
}

export interface ExportTask {
  id: string;
  jobId: number;
  fileName: string;
  fileSize?: string;
  status: ExportStatus;
  createdAt: Date;
  completedAt?: Date;
  errorMessage?: string;
  downloadUrl?: string;
  reportKey: string;
  sectionKey: string;
  reportName?: string;
  filters?: {
    dateFrom: string;
    dateTo: string;
    otherFilters?: any[];
    [key: string]: any;
  };
  paging?: { sort: string; tablekey: string };
  fileExtension?: string;
  detailsId?: string,
}

export interface ExportPdfRequest {
  filters: {
    dateFrom: string;
    dateTo: string;
    otherFilters: Array<{
      name: string;
      operator: string;
      value: string | number;
      valueType?: string;
    }>;
  };
  paging?: {
    sort: string;
    tablekey: string;
  };
  fileExtension?: string;
}

export interface ExportPdfResponse {
  jobId: number;
}

export interface ExportStatusResponse {
  jobId: number;
  status: string;
  downloadUrl?: string;
}

